import DisplayData from "../Components/RecordPage/DisplayData";
import { useState, useEffect } from "react";
import RouteDialog from "../Components/Homepage/RouteDialog";
import { GetSearchData } from "../Components/CRUDPage/FetchData";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { LogInURL } from "../Variables/variable";

let InfoList = ["patient_id", "citizen_id", "name", "gender", "birthday", "disease", "other", "phone"];
let InfoContent = [];
const InfoText = {"patient_id": "病例號", "citizen_id":"身分證字號", "name":"名稱", "gender":"性別", "birthday":"生日", "disease":"其他疾病", "other":"備註", "phone":"電話號碼"};

function BasicInfo() {
    const [targetRoute, setTargetRoute] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [patientData, setPatient] = useState('');

    let navigate = useNavigate();

    useEffect(() => {
        const isLoggedIn = sessionStorage.getItem('isLoggedIn');
        if((!isLoggedIn || isLoggedIn==='false') && !sessionStorage.getItem('access_token')){
            console.log('log out')
            window.location.href = LogInURL;
        }
    }, [navigate])
    
    window.addEventListener('storage', function(e){
        // console.log(e)
        const isLoggedIn = sessionStorage.getItem('isLoggedIn');
        if((!isLoggedIn || isLoggedIn==='false') && !sessionStorage.getItem('access_token')){window.location.href = LogInURL;}
    })   

    const handleOpen = (target, isOpen, patientData) => {
        setTargetRoute(target);
        setIsOpen(isOpen);
        setPatient(patientData);
    }
    const handleClose = () => {
        setTargetRoute(null);
        setIsOpen(false);
        setPatient({patient_id:'', name:''});
    }

    let gettingData = GetSearchData("client_data");
    // console.log("getData:",gettingData);
    if(gettingData.message && gettingData.message === 'Unauthenticated.'){
        console.log("error:",gettingData)
        return(<><h1 className="text-xl flex justify-center p-4">{"some error occured"}</h1></>)
    }
    else if(typeof gettingData === "object" && !gettingData.hasOwnProperty("message")){
        InfoContent = gettingData.data;
    }
    else{
        return (<><h1 className="text-xl flex justify-center p-4">{gettingData}</h1></>)
    }

    return(
        <>
            <ToastContainer 
                        position="top-left"
                        autoClose={2000}
            ></ToastContainer>
            <DisplayData InfoList={InfoList} InfoText={InfoText} handleDialogOpen={handleOpen} InfoContent={InfoContent} WhichPage={'basic_info'}></DisplayData>
            <RouteDialog isOpen={isOpen} targetRoute={targetRoute} handleDialogClose={handleClose} patientData={patientData}></RouteDialog>
        </>
    )
}

export default BasicInfo;